import { TinyColor } from '@ctrl/tinycolor';

/*
 * @Author: chenhe ch10@meitu.com
 * @Date: 2025-09-05 10:44:04
 * @LastEditors: chenhe ch10@meitu.com
 * @LastEditTime: 2025-09-08 18:28:36
 * @FilePath: /roboneo-web/packages/roboneo-sdk/src/utils/colorUtil.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export interface ColorState {
  hex: string;
  rgb: {
    r: number;
    g: number;
    b: number;
    a?: number;
  };
  hsl: {
    h: number;
    s: number;
    l: number;
    a?: number;
  };
  hsv: {
    h: number;
    s: number;
    v: number;
    a?: number;
  };
  source?: string;
}

/**
 * 颜色格式转换
 *
 * @param {string} hex
 * @return {ColorState}
 */
export function formatColor(hex: any): ColorState {
  try {
    const color = new TinyColor(hex);
    return {
      hex: color.toHex8String(), // 带透明度
      rgb: color.toRgb(),
      hsl: color.toHsl(),
      hsv: color.toHsv(),
      source: 'rgb',
    };
  } catch (error) {
    const color = new TinyColor('#ffffffff');
    return {
      hex: color.toHex8String(), // 带透明度
      rgb: color.toRgb(),
      hsl: color.toHsl(),
      hsv: color.toHsv(),
      source: 'rgb',
    };
  }
}

/**
 * 颜色格式转换
 *
 * @param {ColorState} color
 * @return {string}
 */
export function formatColorToRab(color: ColorState): string {
  return `rgba(${color.rgb.r},${color.rgb.g},${color.rgb.b},${color.rgb.a})`;
}
